export interface BroadcastEvent {
  key: string;
  data?: any;
}
